import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const PlaylistCheckIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
        viewBox='0 0 24 24'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <path fillRule='evenodd' clipRule='evenodd' d='M2 6C2 5.44772 2.44772 5 3 5H16C16.5523 5 17 5.44772 17 6C17 6.55228 16.5523 7 16 7H3C2.44772 7 2 6.55228 2 6ZM2 12C2 11.4477 2.44772 11 3 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H3C2.44772 13 2 12.5523 2 12ZM21.7071 15.2929C22.0976 15.6834 22.0976 16.3166 21.7071 16.7071L17.7071 20.7071C17.3166 21.0976 16.6834 21.0976 16.2929 20.7071L14.2929 18.7071C13.9024 18.3166 13.9024 17.6834 14.2929 17.2929C14.6834 16.9024 15.3166 16.9024 15.7071 17.2929L17 18.5858L20.2929 15.2929C20.6834 14.9024 21.3166 14.9024 21.7071 15.2929ZM2 18C2 17.4477 2.44772 17 3 17H11C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H3C2.44772 19 2 18.5523 2 18Z'/>
    </svg>
));
